import { ServiceItem } from '../types';

export const allServices: ServiceItem[] = [
  {
    id: 'opd',
    title: 'OPD',
    titleSinhala: 'බාහිර රෝගී අංශය',
    icon: 'stethoscope',
    bgImage: 'linear-gradient(rgba(46, 125, 50, 0.8), rgba(76, 175, 80, 0.8))',
    description: 'Outpatient Department - General consultations and primary care',
    descriptionSinhala: 'බාහිර රෝගී අංශය - සාමාන්‍ය උපදේශන සහ ප්‍රාථමික සත්කාර',
    stats: { 
      operatingHours: '8:00 AM - 4:00 PM',
      dailyPatients: '150-200',
      consultationFee: 'Free',
      emergencyAvailable: true,
      waitingTime: '30-45 mins',
      doctorsAvailable: 3
    } as any
  },
  {
    id: 'etu',
    title: 'ETU',
    titleSinhala: 'හදිසි ප්‍රතිකාර ඒකකය',
    icon: 'pill',
    bgImage: 'linear-gradient(rgba(211, 47, 47, 0.8), rgba(244, 67, 54, 0.8))',
    description: 'Emergency Treatment Unit - 24/7 emergency medical care',
    descriptionSinhala: 'හදිසි ප්‍රතිකාර ඒකකය - 24/7 හදිසි වෛද්‍ය සත්කාර',
    stats: {
      availability: '24/7',
      responseTime: '< 5 minutes',
      beds: 6,
      equipment: 'Advanced',
      ambulanceService: true,
      specializedCare: 'Trauma, Cardiac, Respiratory'
    } as any
  },
  {
    id: 'icu',
    title: 'ICU',
    titleSinhala: 'දැඩි සත්කාර ඒකකය',
    icon: 'building',
    bgImage: 'linear-gradient(rgba(21, 101, 192, 0.8), rgba(33, 150, 243, 0.8))',
    description: 'Intensive Care Unit - Critical patient care with advanced monitoring',
    descriptionSinhala: 'දැඩි සත්කාර ඒකකය - උසස් අධීක්ෂණ සහිත අධිදූර රෝගී සත්කාර',
    stats: {
      beds: 4,
      ventilators: 2,
      monitoring: '24/7',
      staffRatio: '1:2',
      equipment: 'State-of-the-art',
      admissionCriteria: 'Critical conditions only'
    } as any
  },
  {
    id: 'ncd',
    title: 'NCD',
    titleSinhala: 'නිදන්ගත රෝග ක්ලිනිකය',
    icon: 'mappin',
    bgImage: 'linear-gradient(rgba(255, 143, 0, 0.8), rgba(255, 193, 7, 0.8))',
    description: 'Non-Communicable Disease Clinic - Diabetes, hypertension, heart disease care',
    descriptionSinhala: 'නිදන්ගත රෝග ක්ලිනිකය - දියවැඩියාව, අධි රුධිර පීඩනය, හෘද රෝග සත්කාර',
    stats: {
      clinicDays: 'Monday, Wednesday, Friday',
      consultationTime: '9:00 AM - 12:00 PM',
      services: 'BP monitoring, Blood sugar tests, ECG',
      followUpSchedule: 'Monthly',
      registeredPatients: 800,
      medicationSupply: 'Free government supply'
    } as any
  },
  {
    id: 'dispensary',
    title: 'Dispensary',
    titleSinhala: 'ඖෂධාගාරය',
    icon: 'bed',
    bgImage: 'linear-gradient(rgba(156, 39, 176, 0.8), rgba(186, 104, 200, 0.8))',
    description: 'Medicine dispensing unit - Prescription fulfillment and medication counseling',
    descriptionSinhala: 'ඖෂධ බෙදාහැරීමේ ඒකකය - වට්ටෝරු ඉටුකිරීම සහ ඖෂධ උපදේශන',
    stats: {
      operatingHours: '8:00 AM - 4:30 PM',
      prescriptionsDaily: '300-400',
      medicineStock: '95% availability',
      pharmacist: 'Qualified B.Pharm',
      emergencyStock: 'Available 24/7',
      counselingService: 'Free medication guidance'
    } as any
  },
  {
    id: 'office',
    title: 'Office',
    titleSinhala: 'කාර්යාලය',
    icon: 'usercheck',
    bgImage: 'linear-gradient(rgba(121, 85, 72, 0.8), rgba(161, 136, 127, 0.8))',
    description: 'Administrative office - Patient registration, records, and hospital services',
    descriptionSinhala: 'පරිපාලන කාර්යාලය - රෝගී ලියාපදිංචිය, වාර්තා සහ රෝහල් සේවාවන්',
    stats: {
      services: 'Registration, Certificates, Records',
      operatingHours: '8:00 AM - 4:30 PM',
      onlineServices: 'Partial',
      waitingTime: '15-30 minutes',
      documentsRequired: 'NIC, Previous medical records',
      languages: 'Sinhala, Tamil, English'
    } as any
  },
  {
    id: 'dental',
    title: 'Dental',
    titleSinhala: 'දන්ත ක්ලිනිකය',
    icon: 'clipboard',
    bgImage: 'linear-gradient(rgba(96, 125, 139, 0.8), rgba(144, 164, 174, 0.8))',
    description: 'Dental clinic - Oral health care, extractions, and preventive treatments',
    descriptionSinhala: 'දන්ත ක්ලිනිකය - මුඛ සෞඛ්‍ය සත්කාර, දත් නෙරීම සහ වැළැක්වීමේ ප්‍රතිකාර',
    stats: {
      clinicDays: 'Tuesday, Thursday, Saturday',
      consultationTime: '9:00 AM - 1:00 PM',
      services: 'Extractions, Fillings, Cleaning, Consultations',
      dentalSurgeon: 'Available',
      emergencyTreatment: 'Pain relief available',
      appointmentRequired: 'Walk-in accepted'
    } as any
  },
  {
    id: 'wards',
    title: 'Wards',
    titleSinhala: 'වාට්ටු',
    icon: 'bed',
    bgImage: 'linear-gradient(rgba(76, 175, 80, 0.8), rgba(139, 195, 74, 0.8))',
    description: 'Patient wards - Male, female, and pediatric inpatient care',
    descriptionSinhala: 'රෝගී වාට්ටු - පිරිමි, ගැහැණු සහ ළමා ගෘහස්ථ රෝගී සත්කාර',
    stats: {
      totalBeds: 45,
      maleWard: '20 beds',
      femaleWard: '20 beds',
      pediatricWard: '5 beds',
      visitingHours: '4:00 PM - 6:00 PM',
      nursingCare: '24/7',
      mealsProvided: '3 meals daily'
    } as any
  },
  {
    id: 'qmu',
    title: 'QMU Clinic',
    titleSinhala: 'QMU ක්ලිනිකය',
    icon: 'stethoscope',
    bgImage: 'linear-gradient(rgba(233, 30, 99, 0.8), rgba(240, 98, 146, 0.8))',
    description: 'Quality Management Unit clinic - Health screening and preventive care',
    descriptionSinhala: 'ගුණාත්මක කළමනාකරණ ඒකක ක්ලිනිකය - සෞඛ්‍ය පරීක්ෂණ සහ වැළැක්වීමේ සත්කාර',
    stats: {
      services: 'Health screening, Vaccinations, Health education',
      clinicDays: 'All weekdays',
      consultationTime: '8:30 AM - 3:30 PM',
      screeningTests: 'Blood pressure, BMI, Blood sugar',
      vaccinations: 'Routine immunizations available',
      healthEducation: 'Community programs'
    } as any
  },
  {
    id: 'cssd',
    title: 'CSSD',
    titleSinhala: 'CSSD',
    icon: 'pill',
    bgImage: 'linear-gradient(rgba(63, 81, 181, 0.8), rgba(92, 107, 192, 0.8))',
    description: 'Central Sterile Supply Department - Medical instrument sterilization',
    descriptionSinhala: 'මධ්‍යම වන්ධ්‍යකරණ සැපයුම් අංශය - වෛද්‍ය උපකරණ වන්ධ්‍යකරණය',
    stats: {
      function: 'Sterilization and supply of medical instruments',
      operatingHours: '24/7',
      equipment: 'Autoclave, ETO sterilizers',
      capacity: '500 instruments daily',
      qualityControl: 'ISO standards',
      supplyDepartments: 'All clinical units'
    } as any
  },
  {
    id: 'drugstore',
    title: 'Drug Store',
    titleSinhala: 'ඖෂධ ගබඩාව',
    icon: 'building',
    bgImage: 'linear-gradient(rgba(255, 87, 34, 0.8), rgba(255, 152, 0, 0.8))',
    description: 'Medicine storage facility - Drug inventory and distribution center',
    descriptionSinhala: 'ඖෂධ ගබඩා කිරීමේ පහසුකම - ඖෂධ ඉන්වෙන්ටරි සහ බෙදා හැරීමේ මධ්‍යස්ථානය',
    stats: {
      function: 'Medicine storage and distribution',
      capacity: '6 months supply',
      temperature: 'Climate controlled',
      inventory: 'Computerized system',
      suppliesTo: 'All hospital departments',
      qualityAssurance: 'WHO guidelines'
    } as any
  },
  {
    id: 'heu',
    title: 'HEU',
    titleSinhala: 'සෞඛ්‍ය අධ්‍යාපන ඒකකය',
    icon: 'mappin',
    bgImage: 'linear-gradient(rgba(103, 58, 183, 0.8), rgba(156, 39, 176, 0.8))',
    description: 'Health Education Unit - Community health promotion and education',
    descriptionSinhala: 'සෞඛ්‍ය අධ්‍යාපන ඒකකය - ප්‍රජා සෞඛ්‍ය ප්‍රවර්ධන සහ අධ්‍යාපනය',
    stats: {
      programs: 'Health awareness, Disease prevention',
      targetAudience: 'Patients, Community, Schools',
      activities: 'Workshops, Seminars, Health camps',
      materials: 'Leaflets, Posters, Videos',
      languages: 'Sinhala, Tamil',
      monthlyPrograms: '8-10 sessions'
    } as any
  },
  {
    id: 'theater',
    title: 'Mini Theater',
    titleSinhala: 'කුඩා ශල්‍ය කාමරය',
    icon: 'usercheck',
    bgImage: 'linear-gradient(rgba(0, 150, 136, 0.8), rgba(77, 182, 172, 0.8))',
    description: 'Minor surgery theater - Day surgery and minor procedures',
    descriptionSinhala: 'කුඩා ශල්‍යකර්ම කාමරය - දිවා ශල්‍යකර්ම සහ කුඩා ක්‍රියා පටිපාටි',
    stats: {
      capacity: '2 operating tables',
      procedures: 'Minor surgeries, Wound care, Procedures',
      operatingHours: '8:00 AM - 4:00 PM',
      sterileEnvironment: 'HEPA filtered',
      anesthesia: 'Local anesthesia available',
      surgeonAvailability: 'On-call basis'
    } as any
  },
  {
    id: 'odu',
    title: 'ODU',
    titleSinhala: 'හැදිරි වෛද්‍ය අංශය',
    icon: 'clipboard',
    bgImage: 'linear-gradient(rgba(255, 193, 7, 0.8), rgba(255, 235, 59, 0.8))',
    description: 'Obstetrics Department Unit - Maternity care and delivery services',
    descriptionSinhala: 'හැදිරි වෛද්‍ය අංශ ඒකකය - මාතෘ සත්කාර සහ ප්‍රසව සේවාවන්',
    stats: {
      services: 'Antenatal care, Delivery, Postnatal care',
      deliveryRoom: '2 beds',
      operatingHours: '24/7',
      midwives: '3 qualified staff',
      emergencyDelivery: 'Available',
      familyPlanning: 'Counseling available'
    } as any
  },
  {
    id: 'kitchen',
    title: 'Kitchen',
    titleSinhala: 'මුළුතැන්ගෙය',
    icon: 'bed',
    bgImage: 'linear-gradient(rgba(139, 69, 19, 0.8), rgba(161, 136, 127, 0.8))',
    description: 'Hospital kitchen - Nutritious meal preparation for patients and staff',
    descriptionSinhala: 'රෝහල් මුළුතැන්ගෙය - රෝගීන් සහ කාර්ය මණ්ඩලය සඳහා පෝෂ්‍යදායී ආහාර සකස් කිරීම',
    stats: {
      mealsDaily: '200-250',
      dietTypes: 'Normal, Diabetic, Cardiac, Soft',
      operatingHours: '5:00 AM - 8:00 PM',
      nutritionist: 'Available for consultation',
      hygiene: 'HACCP standards',
      specialDiets: 'Available on prescription'
    } as any
  },
  {
    id: 'ambulance',
    title: 'Ambulance',
    titleSinhala: 'ගිලන් රථය',
    icon: 'stethoscope',
    bgImage: 'linear-gradient(rgba(244, 67, 54, 0.8), rgba(255, 87, 34, 0.8))',
    description: 'Emergency ambulance service - Patient transport and emergency response',
    descriptionSinhala: 'හදිසි ගිලන් රථ සේවාව - රෝගී ප්‍රවාහනය සහ හදිසි ප්‍රතිචාර',
    stats: {
      vehicles: '2 ambulances',
      availability: '24/7',
      equipment: 'Basic life support, Oxygen, Stretcher',
      responseTime: '10-15 minutes local area',
      coverage: 'Weeraketiya and surrounding areas',
      emergencyNumber: '+94 47 224 6260'
    } as any
  },
  {
    id: 'counseling',
    title: 'Counseling',
    titleSinhala: 'උපදේශන සේවාව',
    icon: 'pill',
    bgImage: 'linear-gradient(rgba(33, 150, 243, 0.8), rgba(100, 181, 246, 0.8))',
    description: 'Counseling services - Mental health support and psychological counseling',
    descriptionSinhala: 'උපදේශන සේවාවන් - මානසික සෞඛ්‍ය ආධාර සහ මනෝවිද්‍යා උපදේශන',
    stats: {
      services: 'Individual counseling, Family therapy, Group sessions',
      availability: 'Monday, Wednesday, Friday',
      consultationTime: '2:00 PM - 4:00 PM',
      counselor: 'Qualified mental health professional',
      confidentiality: 'Strictly maintained',
      referralService: 'Available to specialist centers'
    } as any
  }
];

